import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
      return (
        <div className="max-w-2xl mx-auto px-6 py-16 text-center">
          <h2 className="font-display text-2xl">Something went wrong</h2>
          <p className="text-sm text-muted-foreground mt-2">
            We hit a snag rendering this section. Try again or head back home.
          </p>
          <div className="mt-6 flex justify-center gap-2">
            <button
              onClick={this.reset}
              className="rounded-full bg-foreground px-6 py-3 text-[10px] font-bold uppercase tracking-[0.2em] text-background"
            >
              Try again
            </button>
            <a
              href="/"
              className="rounded-full border border-border px-6 py-3 text-[10px] font-bold uppercase tracking-[0.2em]"
            >
              Go home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
